var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-empty-page',[_c('lead-modal',{ref:"leadModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }